/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FaxModuleProvider } from './FaxModuleProvider';
import {
    FaxModuleProviderFromJSON,
    FaxModuleProviderFromJSONTyped,
    FaxModuleProviderToJSON,
} from './FaxModuleProvider';

/**
 * 
 * @export
 * @interface FaxModule
 */
export interface FaxModule {
    /**
     * 
     * @type {boolean}
     * @memberof FaxModule
     */
    enabled?: boolean;
    /**
     * 
     * @type {Array<FaxModuleProvider>}
     * @memberof FaxModule
     */
    providers?: Array<FaxModuleProvider>;
}

/**
 * Check if a given object implements the FaxModule interface.
 */
export function instanceOfFaxModule(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FaxModuleFromJSON(json: any): FaxModule {
    return FaxModuleFromJSONTyped(json, false);
}

export function FaxModuleFromJSONTyped(json: any, ignoreDiscriminator: boolean): FaxModule {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'enabled': !exists(json, 'enabled') ? undefined : json['enabled'],
        'providers': !exists(json, 'providers') ? undefined : ((json['providers'] as Array<any>).map(FaxModuleProviderFromJSON)),
    };
}

export function FaxModuleToJSON(value?: FaxModule | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'enabled': value.enabled,
        'providers': value.providers === undefined ? undefined : ((value.providers as Array<any>).map(FaxModuleProviderToJSON)),
    };
}

